module.exports = __webpack_public_path__ + "fonts/sourcesansprobold.57908371.ttf";